<!--
 * @Author: amywulan
 * @Date: 2021-08-10 12:06:38
 * @LastEditors: amywulan
 * @LastEditTime: 2021-08-11 11:33:33
 * @Description: 
-->
<template>
  <div>
    <!-- 支付按钮 -->
    <PaymentMethod @click.native="handlePay" :noHasPayment="noHasPayment" />
    <!-- 支付列表弹窗 -->
    <!-- <CardPopup v-model="isShowCard" @update="update" /> -->
  </div>
</template>

<script>
import PaymentMethod from './paymentMethod.vue';
// import CardPopup from './cardPopup.vue';
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
  name: 'Payment',
  components: {
    PaymentMethod,
    // CardPopup,
  },
  props: {
    paymentParams: {
      type: Object,
      default: () => {
        // terminal_id:'',//global和外卖单独端的terminal_id不同 18.端来源标识--terminal_id
        // appversion:'',//客户端版本
        // price:'',//realPayPrice，提单页进入不传， 二次小费和欠款进入必传
        // aid:'', //提单页进入有选必传，二次小费和欠款进入不传
        // scene:'',//查询场景，0-提单页，1 - 欠款单还款场景，2 - 二次小费支付场景
        // cartId:'',//提单页进入必传， 二次小费和欠款进入不传
      },
    },
    selectCard: {
      type: Object,
      default: () => {},
    },
    noHasPayment: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowCard: false,
    };
  },
  computed: {
    ...mapState({
      extraInfoList: ({ pay }) => pay.extraInfoList,
      selectedCard: ({ pay }) => pay.selectedCard,
      selectedMent: ({ pay }) => pay.selectedMent,
    }),
  },
  async mounted() {
    if (this.selectCard) {
      this.setSelectedCard(this.selectCard);
    }
  },
  methods: {
    ...mapMutations('pay', ['setSelectedCard', 'setSelectedMent']),
    async handlePay() {
      this.$cardPopup({ paymentParams: this.paymentParams }).then(() => {
        this.setSelectedCard(this.selectedCard);
        this.setSelectedMent(this.selectedCard);
        this.$emit('updatepay', this.selectedCard);
      }).catch(()=> {
        console.log('close cardPopup')
      })
    },
    update(card) {
      this.$emit('updatepay', card);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>